import React from 'react';

import AppActions from '../../actions/app-actions';
import AppStore from '../../stores/app-store';
import Loader from '../common/loader';
import DeviceList from './devicelist';

export default class Rejected extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      count: 0,
      devices: [],
      pageNo: 1,
      pageLength: 20,
      refreshDeviceLength: 10000,
      pageLoading: true
    };

    /** Bind methods to avoid method re-creation */
    this._triggerRefreshTimerBind = this._triggerRefreshTimer.bind(this);
    this._getDevicesBind = this._getDevices.bind(this);
    this._handlePageChangeBind = this._handlePageChange.bind(this);

    /** local property */
    this._unmountError = 'Component unmounted';    
  }

  componentDidMount() {
    this._isMounted = true;
    this._getDevices();
  }
  componentWillUnmount() {
    this._triggerRefreshTimer(false);
    this._isMounted = false;
  }

  _triggerRefreshTimer(trigger) {
    if (trigger && !this.timerId && this._isMounted) {
      this.timerId = setTimeout(this._getDevicesBind, this.state.refreshDeviceLength);
    } else if(!trigger && this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;      
    }
  }

  /*
   * Devices to show
   */
  _getDevices() {
    this._triggerRefreshTimer(false);
    Promise.all([
      AppActions.getDeviceCount('rejected'),
      AppActions.getDevicesByStatus('rejected', this.state.pageNo, this.state.pageLength)])
      .then((results) => {
        if (!this._isMounted) {
          throw new Error(this._unmountError);
        }
        return results;
      })
      .then((results) => {
        let count = results[0];
        let devices = results[1];
        //if devices empty but count not, make both be empty
        if (!(count && devices.length)) {
          count = 0;
          devices = [];
        }
        this.setState({count, devices, pageLoading: false}, () => {
          this._triggerRefreshTimer(true);
        });
      })
      .catch((error) => {
        if (error.message !== this._unmountError) {
          const errorMsg = error.error || 'Please check your connection.';
          this.setState({count: 0, devices: [], pageLoading: false, pageNo: 1}, () => {
            this._triggerRefreshTimer(true);
            AppActions.setSnackbar(errorMsg, 5000, '');
          });
        }
      });
  }

  _handlePageChange(pageNo) {
    this.setState({pageLoading: true, pageNo}, () => {
      this._getDevices();
    });
  }

  render() {
    const deviceLimit = AppStore.getDeviceLimit();
    var limitMaxed = deviceLimit ? deviceLimit <= this.props.acceptedDevices : false;

    return (
      <div className="tab-container">
        <Loader show={this.state.pageLoading} />

        {this.state.devices.length && !this.state.pageLoading ? (
          <div className="padding-bottom">
            <h3 className="align-center">{this.state.count} Blacklisted devices</h3>
            <DeviceList
              {...this.props}
              {...this.state}
              limitMaxed={limitMaxed}
              onPageChange={this._handlePageChangeBind}
              pageTotal={this.state.count}
              refreshDevices={this._getDevicesBind}
              type="rejected"
              updateRefreshTimer={this._triggerRefreshTimerBind}
            />
          </div>
        ) : (
          <div className={this.state.pageLoading ? 'hidden' : 'dashboard-placeholder'}>
            <p>There are no blacklisted  devices</p>
          </div>
        )}
      </div>
    );
  }
}
